import { FC } from 'react';

import { IconProps } from './types';

export const Exchange: FC<IconProps> = ({ size, height = 24, width = 24, color = '#14489D' }) => (
	<svg
		viewBox="0 0 24 24"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
	>
		<g id="icons-/-icons-24-menu-/-birga" stroke="none" fill="none" fillRule="evenodd">
			<path
				fill={color}
				d="M3.039,7.28 C3.162,7.7 3.554,8 4,8 L20,8 C20.446,8 20.838,7.7 20.961,7.28 C21.084,6.85 20.908,6.39 20.53,6.15 L12.53,1.15 C12.205,0.95 11.794,0.95 11.47,1.15 L3.47,6.15 C3.092,6.39 2.916,6.85 3.039,7.28 Z M16.514,6 L7.487,6 L12,3.18 L16.514,6 Z M5,18 C5,18.55 5.448,19 6,19 C6.552,19 7,18.55 7,18 L7,11 C7,10.45 6.552,10 6,10 C5.448,10 5,10.45 5,11 L5,18 Z M3,23 L21,23 C21.553,23 22,22.55 22,22 C22,21.45 21.553,21 21,21 L3,21 C2.448,21 2,21.45 2,22 C2,22.55 2.448,23 3,23 Z M10,19 C9.448,19 9,18.55 9,18 L9,11 C9,10.45 9.448,10 10,10 C10.552,10 11,10.45 11,11 L11,18 C11,18.55 10.552,19 10,19 Z M13,18 C13,18.55 13.447,19 14,19 C14.553,19 15,18.55 15,18 L15,11 C15,10.45 14.553,10 14,10 C13.447,10 13,10.45 13,11 L13,18 Z M18,19 C17.447,19 17,18.55 17,18 L17,11 C17,10.45 17.447,10 18,10 C18.553,10 19,10.45 19,11 L19,18 C19,18.55 18.553,19 18,19 Z"
				id="Combined-Shape"
			/>
		</g>
	</svg>
);
